import { useToast as useChakraToast } from "@chakra-ui/react";

type ToastType = "success" | "error" | "warning" | "info";

interface ToastOptions {
  title?: string;
  message: string;
  type?: ToastType;
  duration?: number;
}

const useToast = () => {
  const toast = useChakraToast();

  return ({ title, message, type = "info", duration = 5000 }: ToastOptions) => {
    toast({
      title: title,
      description: message,
      status: type,
      duration,
      isClosable: true,
      position: "top-right",
    });
  };
};

export default useToast;
